import React, { useCallback } from "react";
import { useChatControllerGetRooms } from "@semo/api-contracts";
import { ChatListItem } from "@semo/shared-chat";
import { Skeleton } from "@semo/shared-ui";
import { MessageSquare } from "@semo/icons";

interface ChatRoomListProps {
  onOpenChat: (roomId: string) => void;
}

export const ChatRoomList: React.FC<ChatRoomListProps> = ({ onOpenChat }) => {
  const { data: roomsData, isLoading } = useChatControllerGetRooms({
    page: 1,
    limit: 50,
  });

  const handleChatClick = useCallback(
    (roomId: string) => {
      onOpenChat(roomId);
    },
    [onOpenChat],
  );

  if (isLoading) {
    return (
      <div className="space-y-4 w-full">
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} className="h-24 w-full rounded-2xl" />
        ))}
      </div>
    );
  }

  const rooms = roomsData?.data?.items || [];

  if (rooms.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-slate-500 gap-4">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
          <MessageSquare className="w-8 h-8 text-slate-400" />
        </div>
        <div className="text-center">
          <p className="text-lg font-medium text-slate-700">
            진행 중인 채팅이 없습니다.
          </p>
          <p className="text-sm text-slate-400">
            견적 요청에 참여하면 채팅방이 생성됩니다.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3 p-1 w-full pb-20">
      {rooms.map((room) => (
        <ChatListItem
          key={room.id}
          partyName={room.userInfo?.name || "알 수 없음"}
          projectName={room.quoteRequest?.projectName}
          projectCode={room.quoteRequest?.requestNumber || ""}
          lastMessage={
            room.lastMessage?.content ||
            (room.latestQuoteMessage
              ? "견적서가 전송되었습니다."
              : "대화 내역 없음")
          }
          timestamp={
            room.lastMessageAt
              ? new Date(room.lastMessageAt).toISOString()
              : room.createdAt
                ? new Date(room.createdAt).toISOString()
                : ""
          }
          unreadCount={room.unreadCount || 0}
          imageUrl={room.userInfo?.profileImageUrl || undefined}
          onClick={() => handleChatClick(room.id)}
        />
      ))}
    </div>
  );
};
